var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M2.08203 5.74349C2.08203 3.90254 3.57442 2.41016 5.41536 2.41016C7.25631 2.41016 8.7487 3.90254 8.7487 5.74349C8.7487 7.58444 7.25631 9.07682 5.41536 9.07682C3.57442 9.07682 2.08203 7.58444 2.08203 5.74349Z",
    stroke: "#858585",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M11.25 14.9105C11.25 13.0695 12.7424 11.5771 14.5833 11.5771C16.4243 11.5771 17.9167 13.0695 17.9167 14.9105C17.9167 16.7514 16.4243 18.2438 14.5833 18.2438C12.7424 18.2438 11.25 16.7514 11.25 14.9105Z",
    stroke: "#858585",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9167 5.74349C17.9167 3.90254 16.4243 2.41016 14.5833 2.41016C12.7424 2.41016 11.25 3.90254 11.25 5.74349C11.25 7.58444 12.7424 9.07682 14.5833 9.07682C16.4243 9.07682 17.9167 7.58444 17.9167 5.74349Z",
    stroke: "#858585",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7487 14.9105C8.7487 13.0695 7.25631 11.5771 5.41536 11.5771C3.57442 11.5771 2.08203 13.0695 2.08203 14.9105C2.08203 16.7514 3.57442 18.2438 5.41536 18.2438C7.25631 18.2438 8.7487 16.7514 8.7487 14.9105Z",
    stroke: "#858585",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppsIcon);
export default __webpack_public_path__ + "static/media/AppsIcon.be3b4a5cf04ebe1257d55890b783abc7.svg";
export { ForwardRef as ReactComponent };